import React from "react";

export default function AppHeader() {
  return (
    <header className="chat-layout-header">
      <h3>Chat</h3>
    </header>
  );
}
